import { HttpClient } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { MatSelectModule } from "@angular/material/select";
import { GkComponentsModule, GkMapModule } from "@gk/gk-modules";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { SharedModule } from "../../shared/shared.module";
import { createTranslateLoader } from "../address-number-request-portal/address-number-request-portal.module";
import { TSFNNewRequestComponent } from "./new-request/new-request.component";
import { TSFNNewRequestFormService } from "./services/new-request-form/new-request-form.service";
import { TreesAndShrubsFallNotificationRoutingModule } from "./trees-and-shrubs-fall-notification-routing.module";
import { TreesAndShrubsFallNotificationComponent } from "./trees-and-shrubs-fall-notification.component";

@NgModule({
  declarations: [
    TreesAndShrubsFallNotificationComponent,
    TSFNNewRequestComponent,
  ],
  imports: [
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    GkMapModule,
    GkComponentsModule,
    TreesAndShrubsFallNotificationRoutingModule,
    MatSelectModule,
  ],
  providers: [TSFNNewRequestFormService],
})
export class TreesAndShrubsFallNotificationModule {}
